import type { AnimeItem } from "@/mocks/anime";

interface AnimeCardProps {
  item: AnimeItem;
  showScore?: boolean;
}

export default function AnimeCard({ item, showScore = true }: AnimeCardProps) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={item.image}
          alt={`${item.title} 番剧海报，${item.tags.join('、')}`}
          title={`${item.title} - 小虎看番推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {showScore && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/80 px-2.5 py-1 text-xs font-bold text-background-50">
            <i className="ri-star-fill text-amber-400" />
            {item.score.toFixed(1)}
          </span>
        )}
        <span className="absolute bottom-3 right-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
          {item.year}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h4 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h4>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {item.tags.map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-xs md:text-sm leading-5 text-foreground-600">
          {item.synopsis}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="text-xs text-foreground-500">{item.episodes} 集</span>
          <span className="text-xs font-medium text-primary-600">{item.category}</span>
        </div>
      </div>
    </article>
  );
}